// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"C0-z","subtitle":"D0-z","wrapper":"E0-z","leftArrow":"F0-z","rightArrow":"G0-z"};